import Controller from '@ember/controller';
import { action } from '@ember/object';
import { cached, tracked } from '@glimmer/tracking';
import { sortByProperties } from 'donor-elf-web/lib/array-utils';
import ContactModel from 'donor-elf-web/models/contact';
import type { ContactMergeIndexRouteModel } from 'donor-elf-web/routes/funds/fund/contacts/contact/merge/index';

function scrubAndSplitContactNameLowerCase(nameLowerCase: string) {
  return nameLowerCase
    .replace(/(,|&)/g, '')
    .replace(/\sand\s/g, ' ')
    .split(' ')
    .filter((x) => x !== '');
}

export default class ContactMergeIndexController extends Controller {
  declare model: ContactMergeIndexRouteModel;

  queryParams = ['q', 'page'];

  @tracked q = '';

  @tracked page = 1;
  perPage = 50;

  @cached
  get sortedContacts(): ContactModel[] {
    return sortByProperties(this.otherContactsWithNameMatches, [
      'matches:desc',
      'contact.name:asc',
    ]).map((x) => x.contact);
  }

  get otherContactsWithNameMatches(): {
    matches: number;
    contact: ContactModel;
  }[] {
    let { contact } = this.model;
    let contactDisplayNames = scrubAndSplitContactNameLowerCase(
      contact.nameLowerCase,
    );
    return this.model.otherContacts.map((otherContact) => {
      return {
        matches: scrubAndSplitContactNameLowerCase(
          otherContact.nameLowerCase,
        ).filter((y) => contactDisplayNames.indexOf(y) >= 0).length,
        contact: otherContact,
      };
    });
  }

  get filteredContacts() {
    let query = (this.q || '').trim().toLowerCase();
    if (query.length === 0) {
      return this.sortedContacts;
    }

    return this.sortedContacts.filter((x) => {
      return x.nameLowerCase.indexOf(query) >= 0;
    });
  }

  get pagedContacts() {
    let offset = (this.page - 1) * this.perPage;
    return this.filteredContacts.slice(offset, offset + this.perPage);
  }

  get totalPages() {
    return Math.ceil(this.filteredContacts.length / this.perPage);
  }

  @action
  templateWillDestroy() {
    this.q = '';
    this.page = 1;
  }

  @action
  changePage(pageNumber: number) {
    this.page = pageNumber;
  }

  @action
  handleSearchInput(e: any) {
    this.q = e.target.value;
    this.page = 1;
  }
}
